/*options*/
/*--affected*/
/*--cache-options*/
/*--cache-dir-path*/
/*--concurrency-number--percentage*/
/*--continueoption*/
/*--cwd-path*/
/*--dangerously-disable-package-manager-check*/
/*--dry----dry-run*/
/*--env-mode-option*/
/*strict*/
/*loose*/
/*--filter-string*/
/*microsyntaxes-for-filtering*/
/*using-a-task-identifier*/
/*advanced-filtering-examples*/
/*--force*/
/*--framework-inference*/
/*--global-deps-file-glob*/
/*--graph-file-name*/
/*--log-order-option*/
/*--log-prefix-option*/
/*--no-cache*/
/*--daemon-and---no-daemon*/
/*--output-logs-option*/
/*--only*/
/*example*/
/*--parallel*/
/*--preflight*/
/*--profile*/
/*--remote-cache-timeout*/
/*--remote-only*/
/*--summarize*/
/*--token*/
/*--team*/
/*--ui*/
/*--verbosity*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "run",
  "description": "`turbo run` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "运行 turbo.json 中指定的任务。"
  }, {
    "heading": "",
    "content": "¥Run tasks specified in turbo.json."
  }, {
    "heading": "",
    "content": "[tasks]：Turborepo 可以同时运行一个或多个任务。要通过 turbo 运行任务，必须在 turbo.json 中指定该任务。"
  }, {
    "heading": "",
    "content": "¥[tasks]: Turborepo can run one or many tasks at the same time. To run a task through turbo, it must be specified in turbo.json."
  }, {
    "heading": "",
    "content": "[options]：选项用于控制 turbo run 命令的行为。可用的标志选项如下所述。"
  }, {
    "heading": "",
    "content": "¥[options]: Options are used to control the behavior of the turbo run command. Available flag options are described below."
  }, {
    "heading": "",
    "content": "[-- [传递给任务的参数]]:你也可以将参数传递给底层脚本。请注意，所有参数都将传递给运行命令中指定的所有任务。"
  }, {
    "heading": "",
    "content": "¥[-- [args passed to tasks]]: You may also pass arguments to the underlying scripts. Note that all arguments will be passed to all tasks that are named in the run command."
  }, {
    "heading": "",
    "content": "turbo run 是 turbo 的别名。turbo run build lint check-types 与 turbo build lint check-types 相同。为了方便使用，我们推荐使用 在 CI 流水线中使用 turbo run、turbo 和 本地全局 turbo。"
  }, {
    "heading": "",
    "content": "¥turbo run is aliased to turbo. turbo run build lint check-types is the\nsame as turbo build lint check-types. We recommend using turbo run in CI\npipelines\nand turbo with global turbo\nlocally for ease of\nuse."
  }, {
    "heading": "",
    "content": "如果没有提供任何任务，turbo 将显示存储库中包可用的任务。"
  }, {
    "heading": "",
    "content": "¥If no tasks are provided, turbo will display what tasks are available for the packages in the repository."
  }, {
    "heading": "选项-options",
    "content": "¥Options"
  }, {
    "heading": "--affected---affected",
    "content": "仅过滤受当前分支更改影响的包。"
  }, {
    "heading": "--affected---affected",
    "content": "¥Filter to only packages that are affected by changes on the current branch."
  }, {
    "heading": "--affected---affected",
    "content": "默认情况下，该标志等效于 --filter=...[main...HEAD]。这从 Git 的角度考虑了 main 和 HEAD 之间的变化。"
  }, {
    "heading": "--affected---affected",
    "content": "¥By default, the flag is equivalent to --filter=...[main...HEAD]. This considers changes between main and HEAD from Git's perspective."
  }, {
    "heading": "--affected---affected",
    "content": "比较需要 base 和 head 之间的所有内容都存在于签出中。如果检出范围太浅，则所有包都将被视为已更改。"
  }, {
    "heading": "--affected---affected",
    "content": "¥The comparison requires everything between base and head to exist in the\ncheckout. If the checkout is too shallow, then all packages will be considered\nchanged."
  }, {
    "heading": "--affected---affected",
    "content": "例如，设置 Git 使用 --filter=blob:none --depth=0 签出将确保 --affected 具有正确的历史记录以正常工作。"
  }, {
    "heading": "--affected---affected",
    "content": "¥For example, setting up Git to check out with --filter=blob:none --depth=0 will ensure --affected has the right history to work correctly."
  }, {
    "heading": "--affected---affected",
    "content": "你可以使用各自的 系统环境变量 覆盖默认基础包和头包。"
  }, {
    "heading": "--affected---affected",
    "content": "¥You can override the default base and head with their respective System Environment Variables."
  }, {
    "heading": "--cache-options---cache-options",
    "content": "默认：local:rw,remote:rw"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥Default: local:rw,remote:rw"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "指定运行的缓存源。接受以逗号分隔的选项列表："
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥Specify caching sources for the run. Accepts a comma-separated list of options:"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "local：使用本地文件系统缓存"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥local: Use the local filesystem cache"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "remote：使用远程缓存"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥remote: Use the Remote Cache"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "当省略缓存源时，读取和写入都将被禁用。"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥When a caching source is omitted, reading and writing are both disabled."
  }, {
    "heading": "--cache-options---cache-options",
    "content": "缓存源使用以下值："
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥Cache sources use the following values:"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "rw：阅读并写入"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥rw: Read and write"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "r：只读"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥r: Read only"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "w：只写"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥w: Write only"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "无 (local:)：不使用缓存。相当于省略缓存源选项。"
  }, {
    "heading": "--cache-options---cache-options",
    "content": "¥None (local:) : Does not use cache. Equivalent to omitting the cache source option."
  }, {
    "heading": "--cache-dir-path---cache-dir-path",
    "content": "默认：.turbo/cache"
  }, {
    "heading": "--cache-dir-path---cache-dir-path",
    "content": "¥Default: .turbo/cache"
  }, {
    "heading": "--cache-dir-path---cache-dir-path",
    "content": "指定文件系统缓存目录。"
  }, {
    "heading": "--cache-dir-path---cache-dir-path",
    "content": "¥Specify the filesystem cache directory."
  }, {
    "heading": "--cache-dir-path---cache-dir-path",
    "content": "更改目录时，请确保该目录位于你的 .gitignore 中。"
  }, {
    "heading": "--cache-dir-path---cache-dir-path",
    "content": "¥Ensure the directory is in your .gitignore when changing it."
  }, {
    "heading": "--cache-dir-path---cache-dir-path",
    "content": "也可以通过 TURBO_CACHE_DIR=example/path 系统变量设置相同的行为。"
  }, {
    "heading": "--cache-dir-path---cache-dir-path",
    "content": "¥The same behavior can also be set via the TURBO_CACHE_DIR=example/path system variable."
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "默认：10"
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "¥Default: 10"
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "设置/限制任务执行的最大并发数。必须是大于或等于 1 的整数，或者像 50% 这样的百分比值。"
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "¥Set/limit the maximum concurrency for task execution. Must be an integer greater than or equal to 1 or a percentage value like 50%."
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "使用 1 强制串行执行（一次执行一个任务）。"
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "¥Use 1 to force serial execution (one task at a time)."
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "使用 100% 使用所有可用的逻辑处理器。"
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "¥Use 100% to use all available logical processors."
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "如果同时传递了 --parallel 标志，则此选项将被忽略。"
  }, {
    "heading": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "¥This option is ignored if the --parallel flag is also passed."
  }, {
    "heading": "--continueoption---continueoption",
    "content": "默认：never"
  }, {
    "heading": "--continueoption---continueoption",
    "content": "¥Default: never"
  }, {
    "heading": "--continueoption---continueoption",
    "content": "指定 turbo 在出现错误（例如，任务的退出代码为非零）时应如何处理当前和待处理的任务。"
  }, {
    "heading": "--continueoption---continueoption",
    "content": "¥Specify how turbo should handle current and pending tasks in the presence of an error (e.g. non-zero exit code from a task)."
  }, {
    "heading": "--continueoption---continueoption",
    "content": "当 --continue=never 发生错误时，turbo 将取消所有任务。"
  }, {
    "heading": "--continueoption---continueoption",
    "content": "¥When --continue=never and an error occurs, turbo will cancel all tasks."
  }, {
    "heading": "--continueoption---continueoption",
    "content": "当 --continue=dependencies-successful 发生错误时，turbo 将取消依赖任务。依赖已成功的任务将继续运行。"
  }, {
    "heading": "--continueoption---continueoption",
    "content": "¥When --continue=dependencies-successful and an error occurs, turbo will cancel dependent tasks. Tasks whose dependencies have succeeded will continue to run."
  }, {
    "heading": "--continueoption---continueoption",
    "content": "当 --continue=always 发生错误时，turbo 将继续运行所有任务，即使是依赖失败的任务。"
  }, {
    "heading": "--continueoption---continueoption",
    "content": "¥When --continue=always and an error occurs, turbo will continue running all tasks, even those whose dependencies have failed."
  }, {
    "heading": "--continueoption---continueoption",
    "content": "当 --continue 未指定值时，它将默认为 always。"
  }, {
    "heading": "--continueoption---continueoption",
    "content": "¥When --continue is specified without a value, it will default to always."
  }, {
    "heading": "--continueoption---continueoption",
    "content": "在所有情况下，turbo 都将以执行期间遇到的最高退出代码值退出。"
  }, {
    "heading": "--continueoption---continueoption",
    "content": "¥In all cases, turbo will exit with the highest exit code value encountered during execution."
  }, {
    "heading": "--cwd-path---cwd-path",
    "content": "默认：根目录 turbo.json"
  }, {
    "heading": "--cwd-path---cwd-path",
    "content": "¥Default: Directory of root turbo.json"
  }, {
    "heading": "--cwd-path---cwd-path",
    "content": "设置命令的工作目录。"
  }, {
    "heading": "--cwd-path---cwd-path",
    "content": "¥Set the working directory of the command."
  }, {
    "heading": "--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
    "content": "Turborepo 使用你仓库的锁文件来确定缓存行为、软件包图表 等。因此，我们使用 packageManager 字段 来帮助你稳定 Turborepo。"
  }, {
    "heading": "--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
    "content": "¥Turborepo uses your repository's lockfile to determine caching behavior, Package Graphs, and more. Because of this, we use the packageManager field to help you stabilize your Turborepo."
  }, {
    "heading": "--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
    "content": "为了帮助增量迁移或在无法使用 packageManager 字段的情况下，你可以使用 --dangerously-disable-package-manager-check 退出此检查，并承担不稳定的锁文件产生不可预测行为的风险。禁用后，Turborepo 将尽力查找适用于该存储库的包管理器。"
  }, {
    "heading": "--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
    "content": "¥To help with incremental migration or in situations where you cannot use the packageManager field, you may use --dangerously-disable-package-manager-check to opt out of this check and assume the risks of unstable lockfiles producing unpredictable behavior. When disabled, Turborepo will attempt a best-effort discovery of the intended package manager meant for the repository."
  }, {
    "heading": "--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
    "content": "你也可以使用 turbo.json 中的配置 或 TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK 环境变量退出此检查，以获得更广泛的覆盖范围。"
  }, {
    "heading": "--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
    "content": "¥You may also opt out of this check using configuration in\nturbo.json\nor the\nTURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK\nenvironment variable for broader coverage."
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "显示将要运行的包和任务的详细信息，而不是执行任务。"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "¥Instead of executing tasks, display details about the packages and tasks that would be run."
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "指定 --dry=json 以获取 JSON 格式的输出。"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "¥Specify --dry=json to get the output in JSON format."
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "任务详细信息包含以下有用信息（列表并非详尽）："
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "¥Task details include useful information like (list is non-exhaustive):"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "字段"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "描述"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "taskId"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "任务 ID，格式为 package-name#task-name"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "task"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "要执行的任务名称"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "package"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "运行任务的包"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "hash"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "任务的哈希值（用于缓存）"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "hashOfExternalDependencies"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "全局哈希值"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "command"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "用于运行任务的命令"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "inputs"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "用于哈希计算的文件输入列表"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "outputs"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "已缓存的文件输出列表"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "dependencies"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "必须在此任务之前运行的任务"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "dependents"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "必须在此任务之后运行的任务"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "environmentVariables"
  }, {
    "heading": "--dry----dry-run---dry----dry-run",
    "content": "env 和 passThroughEnv 中指定的环境变量列表"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "type: string"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "控制任务运行时可用的环境变量。"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "¥Controls the available environment variables in the task's runtime."
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "PATH、SHELL 和 SYSTEMROOT 始终可用于该任务。"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "¥PATH, SHELL, and SYSTEMROOT are always available to the task."
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "option"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "description"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "strict(默认)"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "仅允许明确列出的环境变量可用"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "loose"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "允许所有环境变量可用"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "也可以通过 TURBO_ENV_MODE=strict 系统变量设置相同的行为。"
  }, {
    "heading": "--env-mode-option---env-mode-option",
    "content": "¥The same behavior can also be set via the TURBO_ENV_MODE=strict system variable."
  }, {
    "heading": "strict-strict",
    "content": "只有以下键中指定的环境变量才可用于任务："
  }, {
    "heading": "strict-strict",
    "content": "¥Only environment variables specified in the following keys are\navailable to the task:"
  }, {
    "heading": "strict-strict",
    "content": "env"
  }, {
    "heading": "strict-strict",
    "content": "passThroughEnv"
  }, {
    "heading": "strict-strict",
    "content": "globalEnv"
  }, {
    "heading": "strict-strict",
    "content": "globalPassThroughEnv"
  }, {
    "heading": "strict-strict",
    "content": "如果指定或推断了严格模式，则所有任务都将以 strict 模式运行，无论其配置如何。"
  }, {
    "heading": "strict-strict",
    "content": "¥If Strict Mode is specified or inferred, all tasks are run in strict mode,\nregardless of their configuration."
  }, {
    "heading": "loose-loose",
    "content": "计算机上的所有环境变量都可供任务运行时使用。"
  }, {
    "heading": "loose-loose",
    "content": "¥All environment variables on the machine are made available to the task's runtime."
  }, {
    "heading": "loose-loose",
    "content": "当环境变量未包含在上述 strict 中列出的键的缓存中时，这可能很危险。在 loose 模式下，你更有可能从缓存中恢复包含错误环境变量的包版本。"
  }, {
    "heading": "loose-loose",
    "content": "¥This can be dangerous when environment variables are not accounted for in\ncaching with the keys listed in strict above. You're much more likely to\nrestore a version of your package with wrong environment variables from cache\nin loose mode."
  }, {
    "heading": "--filter-string---filter-string",
    "content": "从你的代码库图中指定要执行的目标。可以组合多个过滤器来选择不同的目标集。"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "¥Specify targets to execute from your repository's graph. Multiple filters can be combined to select distinct sets of targets."
  }, {
    "heading": "--filter-string---filter-string",
    "content": "可以组合使用过滤器来创建包、目录和 Git 提交的组合。"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "¥Filters can be combined to create combinations of packages, directories, and git commits."
  }, {
    "heading": "--filter-string---filter-string",
    "content": "目标类型"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "描述"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "示例"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "包"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "在 package.json 中按名称选择一个包。"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "turbo run build --filter=ui"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "目录"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "指定用于捕获要运行任务的软件包列表的目录。与其他过滤器一起使用时，必须包含在 {} 中。"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "turbo run build --filter=./apps/*"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "Git 提交"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "使用 Git 说明符，指定包含源代码控制更改的包。必须包含在 [] 中。"
  }, {
    "heading": "--filter-string---filter-string",
    "content": "turbo run build --filter=[HEAD^1]"
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "¥Microsyntaxes for filtering"
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "!：从选择中取反目标。"
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "¥!: Negate targets from the selection."
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "... 使用包：选择 软件包图表 中相对于目标的所有包。在包名称前使用 ... 将选择目标的依赖，而在包名称后使用 ... 将选择目标的依赖。"
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "¥... using packages: Select all packages in the Package Graph relative to the target. Using ... before the package name will select dependents of the target while using ... after the package name will select dependencies of the target."
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "... 使用 Git 提交：使用 [<from commit>]...[<to commit>] 选择一个范围。"
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "¥... using Git commits: Select a range using [<from commit>]...[<to commit>]."
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "^：使用 ... 时，请从选择中省略目标。"
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "¥^: Omit the target from the selection when using ...."
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "有关过滤的深入讨论和实际用例，请访问 正在运行的任务页面。"
  }, {
    "heading": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "¥For in-depth discussion and practical use cases of filtering, visit the Running Tasks page."
  }, {
    "heading": "使用任务标识符-using-a-task-identifier",
    "content": "¥Using a task identifier"
  }, {
    "heading": "使用任务标识符-using-a-task-identifier",
    "content": "你还可以以 package-name#task-name 的格式为特定包运行特定任务。"
  }, {
    "heading": "使用任务标识符-using-a-task-identifier",
    "content": "¥You can also run a specific task for a specific package in the format of package-name#task-name."
  }, {
    "heading": "使用任务标识符-using-a-task-identifier",
    "content": "这还将运行任务的依赖。要运行不包含依赖的任务，请使用 --only 标志。"
  }, {
    "heading": "使用任务标识符-using-a-task-identifier",
    "content": "¥This will also run the task's dependencies. To run a task without its\ndependencies, use the --only flag."
  }, {
    "heading": "高级过滤示例-advanced-filtering-examples",
    "content": "¥Advanced filtering examples"
  }, {
    "heading": "高级过滤示例-advanced-filtering-examples",
    "content": "你可以组合多个过滤器以进一步优化你的目标。多个过滤器组合成一个联合体，取反的过滤器会从联合体的结果中删除相应的包。"
  }, {
    "heading": "高级过滤示例-advanced-filtering-examples",
    "content": "¥You can combine multiple filters to further refine your targets. Multiple filters are combined as a union, with negated filters removing packages from the result of the union."
  }, {
    "heading": "--force---force",
    "content": "忽略现有的缓存文件并重新执行所有任务。"
  }, {
    "heading": "--force---force",
    "content": "¥Ignore existing cached artifacts and re-execute all tasks."
  }, {
    "heading": "--force---force",
    "content": "--force 将覆盖现有的任务缓存。"
  }, {
    "heading": "--force---force",
    "content": "¥--force will overwrite existing task caches."
  }, {
    "heading": "--force---force",
    "content": "也可以通过 TURBO_FORCE 环境变量 设置相同的行为。"
  }, {
    "heading": "--force---force",
    "content": "¥The same behavior can also be set via the TURBO_FORCE environment variable."
  }, {
    "heading": "--framework-inference---framework-inference",
    "content": "默认：true"
  }, {
    "heading": "--framework-inference---framework-inference",
    "content": "¥Default: true"
  }, {
    "heading": "--framework-inference---framework-inference",
    "content": "指定是否对任务执行 框架推断。"
  }, {
    "heading": "--framework-inference---framework-inference",
    "content": "¥Specify whether or not to do Framework Inference for tasks."
  }, {
    "heading": "--framework-inference---framework-inference",
    "content": "当 false 匹配时，自动环境变量包含 被禁用。"
  }, {
    "heading": "--framework-inference---framework-inference",
    "content": "¥When false, automatic environment variable inclusion is disabled."
  }, {
    "heading": "--global-deps-file-glob---global-deps-file-glob",
    "content": "指定要进行哈希处理的全局文件系统依赖。适用于 .env 以及根目录中影响多个包的文件。"
  }, {
    "heading": "--global-deps-file-glob---global-deps-file-glob",
    "content": "¥Specify glob of global filesystem dependencies to be hashed. Useful for .env and files in the root directory that impact multiple packages."
  }, {
    "heading": "--global-deps-file-glob---global-deps-file-glob",
    "content": "我们建议在 turbo.json 中指定你想要在 globalDependencies 键 中包含哈希值的文件全局变量，以确保它们始终被考虑在内。"
  }, {
    "heading": "--global-deps-file-glob---global-deps-file-glob",
    "content": "¥We recommend specifying file globs that you'd like to include your hashes in\nthe globalDependencies key in\nturbo.json to make sure they are always accounted for."
  }, {
    "heading": "--graph-file-name---graph-file-name",
    "content": "默认：dot"
  }, {
    "heading": "--graph-file-name---graph-file-name",
    "content": "¥Default: dot"
  }, {
    "heading": "--graph-file-name---graph-file-name",
    "content": "此命令可以输出一个图文件：svg、png、jpg、pdf、json、html、mermaid 或 dot。"
  }, {
    "heading": "--graph-file-name---graph-file-name",
    "content": "¥This command can output a graph file: svg, png, jpg, pdf, json, html, mermaid, or dot."
  }, {
    "heading": "--graph-file-name---graph-file-name",
    "content": "如果未安装 Graphviz 或未提供文件名，此命令会将点图打印到 stdout。"
  }, {
    "heading": "--graph-file-name---graph-file-name",
    "content": "¥If Graphviz is not installed, or no filename is provided, this command prints the dot graph to stdout."
  }, {
    "heading": "--graph-file-name---graph-file-name",
    "content": "已知 Bug：所有可能的任务节点都将立即添加到图中，即使该脚本实际上并不存在于给定包中。这不会影响执行，但图表可能会夸大所涉及的包和任务的数量。"
  }, {
    "heading": "--graph-file-name---graph-file-name",
    "content": "¥Known Bug: All possible task nodes will be added to the graph at the\nmoment, even if that script does not actually exist in a given package. This\nhas no impact on execution, but the graph may overstate the number of packages\nand tasks involved."
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "默认：auto"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "¥Default: auto"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "设置日志输出的顺序。"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "¥Set the ordering for log output."
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "默认情况下，turbo 将在 CI 环境中使用 grouped 日志，在其他地方使用 stream 日志。使用 终端 UI 时，此标志不适用。"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "¥By default, turbo will use grouped logs in CI environments and stream logs everywhere else. This flag is not applicable when using the terminal UI."
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "选项"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "描述"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "stream"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "输出可用后立即显示"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "grouped"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "按任务分组输出"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "auto"
  }, {
    "heading": "--log-order-option---log-order-option",
    "content": "turbo 根据自身的启发式方法进行决策"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "默认：auto"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "¥Default: auto"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "控制运行任务时生成的日志行的 <package>:<task>: 前缀。"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "¥Control the <package>:<task>: prefix for log lines produced when running tasks."
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "选项"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "描述"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "task"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "强制在日志中添加 <package>:<task>: 前缀"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "none"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "不支持前缀"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "auto"
  }, {
    "heading": "--log-prefix-option---log-prefix-option",
    "content": "turbo 根据自身的启发式方法进行决策"
  }, {
    "heading": "--no-cache---no-cache",
    "content": "此标志已弃用，并将在未来的主要版本中移除。请改用 --cache 标志。"
  }, {
    "heading": "--no-cache---no-cache",
    "content": "¥This flag is deprecated and will be removed in a future major release. Please\nuse the --cache flag instead."
  }, {
    "heading": "--no-cache---no-cache",
    "content": "默认 false"
  }, {
    "heading": "--no-cache---no-cache",
    "content": "¥Default false"
  }, {
    "heading": "--no-cache---no-cache",
    "content": "不要缓存任务结果。"
  }, {
    "heading": "--no-cache---no-cache",
    "content": "¥Do not cache results of the task."
  }, {
    "heading": "--daemon-和---no-daemon---daemon-and---no-daemon",
    "content": "¥--daemon and --no-daemon"
  }, {
    "heading": "--daemon-和---no-daemon---daemon-and---no-daemon",
    "content": "turbo 可以运行后台进程，预先计算用于确定需要完成的工作的值。此独立进程（守护进程）是一种优化，并非 turbo 正常运行所必需的。"
  }, {
    "heading": "--daemon-和---no-daemon---daemon-and---no-daemon",
    "content": "¥turbo can run a background process to pre-calculate values used for determining work that needs to be done. This standalone process (daemon) is an optimization, and not required for proper functioning of turbo."
  }, {
    "heading": "--daemon-和---no-daemon---daemon-and---no-daemon",
    "content": "使用 turbo.json 中的 daemon 字段 为你的存储库设置默认守护进程用法。传递 --daemon 要求 turbo 使用独立进程，而 --no-daemon 指示 turbo 避免使用或创建独立进程。"
  }, {
    "heading": "--daemon-和---no-daemon---daemon-and---no-daemon",
    "content": "¥The default daemon usage is set for your repository using the daemon field in turbo.json. Passing --daemon requires turbo to use the standalone process, while --no-daemon instructs turbo to avoid using or creating the standalone process."
  }, {
    "heading": "--daemon-和---no-daemon---daemon-and---no-daemon",
    "content": "也可以通过 TURBO_DAEMON=true 系统变量设置相同的行为。"
  }, {
    "heading": "--daemon-和---no-daemon---daemon-and---no-daemon",
    "content": "¥The same behavior can also be set via the TURBO_DAEMON=true system variable."
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "默认：full"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "¥Default: full"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "设置输出日志类型，如果 turbo.json 中已定义，则覆盖 outputLogs。"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "¥Set type of output logging, overriding outputLogs if it's defined in turbo.json."
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "选项"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "描述"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "full"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "显示所有日志"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "hash-only"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "仅显示任务的哈希值"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "new-only"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "仅显示缓存未命中的日志"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "errors-only"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "仅显示任务失败的日志"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "none"
  }, {
    "heading": "--output-logs-option---output-logs-option",
    "content": "隐藏所有任务日志"
  }, {
    "heading": "--only---only",
    "content": "默认：false"
  }, {
    "heading": "--only---only",
    "content": "¥Default: false"
  }, {
    "heading": "--only---only",
    "content": "限制执行仅包含指定的任务。"
  }, {
    "heading": "--only---only",
    "content": "¥Restricts execution to include specified tasks only."
  }, {
    "heading": "示例-example",
    "content": "¥Example"
  }, {
    "heading": "示例-example",
    "content": "给定以下 turbo.json："
  }, {
    "heading": "示例-example",
    "content": "¥Given this turbo.json:"
  }, {
    "heading": "示例-example",
    "content": "该命令将仅执行每个包中的 test 任务。它不会运行 build。"
  }, {
    "heading": "示例-example",
    "content": "¥The command will only execute the test tasks in each package. It will not run build."
  }, {
    "heading": "示例-example",
    "content": "此外，--only 将仅运行指定包中的任务，不包括依赖。例如，turbo run build --filter=web --only 将仅运行 web 包中的 build 脚本。"
  }, {
    "heading": "示例-example",
    "content": "¥Additionally, --only will only run tasks in specified packages, excluding dependencies. For example, turbo run build --filter=web --only, will only run the build script in the web package."
  }, {
    "heading": "--parallel---parallel",
    "content": "默认：false"
  }, {
    "heading": "--parallel---parallel",
    "content": "¥Default: false"
  }, {
    "heading": "--parallel---parallel",
    "content": "在包之间并行运行命令，忽略任务依赖图。"
  }, {
    "heading": "--parallel---parallel",
    "content": "¥Run commands in parallel across packages, ignoring the task dependency graph."
  }, {
    "heading": "--parallel---parallel",
    "content": "--parallel 标志通常用于长时间运行且不会退出的 \"dev\" 或 \"watch\" 任务。从 turbo@1.7 开始，我们建议改用 persistent 配置这些任务。"
  }, {
    "heading": "--parallel---parallel",
    "content": "¥The --parallel flag is typically used for long-running \"dev\" or \"watch\"\ntasks that don't exit. Starting in turbo@1.7, we recommend configuring these\ntasks using persistent instead."
  }, {
    "heading": "--preflight---preflight",
    "content": "仅在配置了远程缓存时适用。允许在每个缓存工件和分析请求之前发送预检请求。后续的上传和下载将遵循重定向。"
  }, {
    "heading": "--preflight---preflight",
    "content": "¥Only applicable when Remote Caching is configured. Enables sending a preflight request before every cache artifact and analytics request. The follow-up upload and download will follow redirects."
  }, {
    "heading": "--preflight---preflight",
    "content": "也可以通过 TURBO_PREFLIGHT=true 系统变量设置相同的行为。"
  }, {
    "heading": "--preflight---preflight",
    "content": "¥The same behavior can also be set via the TURBO_PREFLIGHT=true system variable."
  }, {
    "heading": "--profile---profile",
    "content": "以 Chrome Tracing 格式生成运行跟踪，你可以使用它来分析性能。"
  }, {
    "heading": "--profile---profile",
    "content": "¥Generates a trace of the run in Chrome Tracing format that you can use to analyze performance."
  }, {
    "heading": "--profile---profile",
    "content": "你必须使用 --profile 提供详细程度标志（-v、-vv 或 -vvv）才能生成跟踪。"
  }, {
    "heading": "--profile---profile",
    "content": "¥You must provide a verbosity flag (-v, -vv, or -vvv) with --profile to produce a trace."
  }, {
    "heading": "--profile---profile",
    "content": "配置文件可以在 Perfetto 等工具中查看。"
  }, {
    "heading": "--profile---profile",
    "content": "¥Profiles can be viewed in a tool like Perfetto."
  }, {
    "heading": "--remote-cache-timeout---remote-cache-timeout",
    "content": "默认：30"
  }, {
    "heading": "--remote-cache-timeout---remote-cache-timeout",
    "content": "¥Default: 30"
  }, {
    "heading": "--remote-cache-timeout---remote-cache-timeout",
    "content": "设置远程缓存操作的超时时间（以秒为单位）。"
  }, {
    "heading": "--remote-cache-timeout---remote-cache-timeout",
    "content": "¥Set the timeout for Remote Cache operations in seconds."
  }, {
    "heading": "--remote-only---remote-only",
    "content": "此标志已弃用，并将在未来的主要版本中移除。请改用 --cache 标志。"
  }, {
    "heading": "--remote-only---remote-only",
    "content": "¥This flag is deprecated and will be removed in a future major release. Please\nuse the --cache flag instead."
  }, {
    "heading": "--remote-only---remote-only",
    "content": "默认：false"
  }, {
    "heading": "--remote-only---remote-only",
    "content": "¥Default: false"
  }, {
    "heading": "--remote-only---remote-only",
    "content": "忽略所有任务的本地文件系统缓存，使用远程缓存读取和缓存任务输出。"
  }, {
    "heading": "--remote-only---remote-only",
    "content": "¥Ignore the local filesystem cache for all tasks, using Remote Cache for reading and caching task outputs."
  }, {
    "heading": "--summarize---summarize",
    "content": "在 .turbo/runs 中生成一个包含运行元数据的 JSON 文件，其中包括："
  }, {
    "heading": "--summarize---summarize",
    "content": "¥Generates a JSON file in .turbo/runs containing metadata about the run, including:"
  }, {
    "heading": "--summarize---summarize",
    "content": "受影响的软件包"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥Affected packages"
  }, {
    "heading": "--summarize---summarize",
    "content": "已执行的任务（包括其时间和哈希值）"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥Executed tasks (including their timings and hashes)"
  }, {
    "heading": "--summarize---summarize",
    "content": "缓存的 artifact 中包含的所有文件"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥All the files included in the cached artifact"
  }, {
    "heading": "--summarize---summarize",
    "content": "此标志有助于调试以确定以下事项："
  }, {
    "heading": "--summarize---summarize",
    "content": "¥This flag can be helpful for debugging to determine things like:"
  }, {
    "heading": "--summarize---summarize",
    "content": "turbo 如何解释 inputs 和 outputs 的 glob 语法"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥How turbo interpreted your glob syntax for inputs and outputs"
  }, {
    "heading": "--summarize---summarize",
    "content": "两次任务运行之间哪些输入发生了变化会导致缓存未命中？"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥What inputs changed between two task runs to produce a cache miss"
  }, {
    "heading": "--summarize---summarize",
    "content": "任务时间如何随时间变化"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥How task timings changed over time"
  }, {
    "heading": "--summarize---summarize",
    "content": "虽然 Turborepo 本身没有运行摘要 UI 查看器，但有一些社区开发的工具可供使用："
  }, {
    "heading": "--summarize---summarize",
    "content": "¥While there is not a Turborepo-native Run Summaries UI viewer, there are\nseveral community-built tools available:"
  }, {
    "heading": "--summarize---summarize",
    "content": "https://turbo.nullvoxpopuli.com - 基于 Web 的运行摘要 UI 查看器"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥https://turbo.nullvoxpopuli.com - Web-based UI viewer for Run Summaries"
  }, {
    "heading": "--summarize---summarize",
    "content": "turborepo-summary - 从 Turborepo 运行摘要 JSON 输出生成易于阅读的报告"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥turborepo-summary - Generate human-readable reports from Turborepo run summary JSON output"
  }, {
    "heading": "--summarize---summarize",
    "content": "turborepo-summary-action - GitHub Action 将 turborepo-summary 封装起来，并将其附加到 GitHub Actions 作业摘要"
  }, {
    "heading": "--summarize---summarize",
    "content": "¥turborepo-summary-action - GitHub Action wrapping turborepo-summary to append them to GitHub Actions Job Summary"
  }, {
    "heading": "--token---token",
    "content": "用于远程缓存的承载令牌。与 --team 标志结合使用，在非交互式 shell 中运行非常有用。"
  }, {
    "heading": "--token---token",
    "content": "¥A bearer token for Remote Caching. Useful for running in non-interactive shells in combination with the --team flag."
  }, {
    "heading": "--token---token",
    "content": "此值也可以使用 TURBO_TOKEN 系统变量 设置。如果两者都存在，则标志值将覆盖系统变量。"
  }, {
    "heading": "--token---token",
    "content": "¥This value can also be set using the TURBO_TOKEN system variable. If both are present, the flag value will override the system variable."
  }, {
    "heading": "--token---token",
    "content": "如果你正在使用 Vercel 远程缓存 并在 Vercel 上构建项目，则无需使用此标志。此值将自动为你设置。"
  }, {
    "heading": "--token---token",
    "content": "¥If you are using Vercel Remote\nCache and building your\nproject on Vercel, you do not need to use this flag. This value will be\nautomatically set for you."
  }, {
    "heading": "--team---team",
    "content": "远程缓存团队的 slug。与 --token 标志结合使用，在非交互式 shell 中运行非常有用。"
  }, {
    "heading": "--team---team",
    "content": "¥The slug of the Remote Cache team. Useful for running in non-interactive shells in combination with the --token flag."
  }, {
    "heading": "--team---team",
    "content": "此值也可以使用 TURBO_TEAM 系统变量 设置。如果两者都存在，则标志值将覆盖系统变量。"
  }, {
    "heading": "--team---team",
    "content": "¥This value can also be set using the TURBO_TEAM system variable. If both are present, the flag value will override the system variable."
  }, {
    "heading": "--ui---ui",
    "content": "指定用于输出的 UI。接受 stream 或 tui。"
  }, {
    "heading": "--ui---ui",
    "content": "¥Specify the UI to use for output. Accepts stream or tui."
  }, {
    "heading": "--verbosity---verbosity",
    "content": "要指定日志级别，请使用 --verbosity=<num> 或 -v, -vv, -vvv。"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "¥To specify log level, use --verbosity=<num> or -v, -vv, -vvv."
  }, {
    "heading": "--verbosity---verbosity",
    "content": "级别"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "标志值"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "简写"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "信息"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "--verbosity=1"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "-v"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "调试"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "--verbosity=2"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "-vv"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "跟踪"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "--verbosity=3"
  }, {
    "heading": "--verbosity---verbosity",
    "content": "-vvv"
  }],
  "headings": [{
    "id": "选项-options",
    "content": "选项 /*options*/"
  }, {
    "id": "--affected---affected",
    "content": "--affected /*--affected*/"
  }, {
    "id": "--cache-options---cache-options",
    "content": "--cache <options> /*--cache-options*/"
  }, {
    "id": "--cache-dir-path---cache-dir-path",
    "content": "--cache-dir <path> /*--cache-dir-path*/"
  }, {
    "id": "--concurrency-number--percentage---concurrency-number--percentage",
    "content": "--concurrency <number | percentage> /*--concurrency-number--percentage*/"
  }, {
    "id": "--continueoption---continueoption",
    "content": "--continue[=<option>] /*--continueoption*/"
  }, {
    "id": "--cwd-path---cwd-path",
    "content": "--cwd <path> /*--cwd-path*/"
  }, {
    "id": "--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
    "content": "--dangerously-disable-package-manager-check /*--dangerously-disable-package-manager-check*/"
  }, {
    "id": "--dry----dry-run---dry----dry-run",
    "content": "--dry / --dry-run /*--dry----dry-run*/"
  }, {
    "id": "--env-mode-option---env-mode-option",
    "content": "--env-mode <option> /*--env-mode-option*/"
  }, {
    "id": "strict-strict",
    "content": "strict /*strict*/"
  }, {
    "id": "loose-loose",
    "content": "loose /*loose*/"
  }, {
    "id": "--filter-string---filter-string",
    "content": "--filter <string> /*--filter-string*/"
  }, {
    "id": "用于过滤的微语法-microsyntaxes-for-filtering",
    "content": "用于过滤的微语法 /*microsyntaxes-for-filtering*/"
  }, {
    "id": "使用任务标识符-using-a-task-identifier",
    "content": "使用任务标识符 /*using-a-task-identifier*/"
  }, {
    "id": "高级过滤示例-advanced-filtering-examples",
    "content": "高级过滤示例 /*advanced-filtering-examples*/"
  }, {
    "id": "--force---force",
    "content": "--force /*--force*/"
  }, {
    "id": "--framework-inference---framework-inference",
    "content": "--framework-inference /*--framework-inference*/"
  }, {
    "id": "--global-deps-file-glob---global-deps-file-glob",
    "content": "--global-deps <file glob> /*--global-deps-file-glob*/"
  }, {
    "id": "--graph-file-name---graph-file-name",
    "content": "--graph <file name> /*--graph-file-name*/"
  }, {
    "id": "--log-order-option---log-order-option",
    "content": "--log-order <option> /*--log-order-option*/"
  }, {
    "id": "--log-prefix-option---log-prefix-option",
    "content": "--log-prefix <option> /*--log-prefix-option*/"
  }, {
    "id": "--no-cache---no-cache",
    "content": "--no-cache /*--no-cache*/"
  }, {
    "id": "--daemon-和---no-daemon---daemon-and---no-daemon",
    "content": "--daemon 和 --no-daemon /*--daemon-and---no-daemon*/"
  }, {
    "id": "--output-logs-option---output-logs-option",
    "content": "--output-logs <option> /*--output-logs-option*/"
  }, {
    "id": "--only---only",
    "content": "--only /*--only*/"
  }, {
    "id": "示例-example",
    "content": "示例 /*example*/"
  }, {
    "id": "--parallel---parallel",
    "content": "--parallel /*--parallel*/"
  }, {
    "id": "--preflight---preflight",
    "content": "--preflight /*--preflight*/"
  }, {
    "id": "--profile---profile",
    "content": "--profile /*--profile*/"
  }, {
    "id": "--remote-cache-timeout---remote-cache-timeout",
    "content": "--remote-cache-timeout /*--remote-cache-timeout*/"
  }, {
    "id": "--remote-only---remote-only",
    "content": "--remote-only /*--remote-only*/"
  }, {
    "id": "--summarize---summarize",
    "content": "--summarize /*--summarize*/"
  }, {
    "id": "--token---token",
    "content": "--token /*--token*/"
  }, {
    "id": "--team---team",
    "content": "--team /*--team*/"
  }, {
    "id": "--ui---ui",
    "content": "--ui /*--ui*/"
  }, {
    "id": "--verbosity---verbosity",
    "content": "--verbosity /*--verbosity*/"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#选项-options",
  title: _jsx(_Fragment, {
    children: "选项 "
  })
}, {
  depth: 3,
  url: "#--affected---affected",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--affected"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--cache-options---cache-options",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--cache <options>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--cache-dir-path---cache-dir-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--cache-dir <path>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--concurrency-number--percentage---concurrency-number--percentage",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--concurrency <number | percentage>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--continueoption---continueoption",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--continue[=<option>]"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--cwd-path---cwd-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--cwd <path>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--dangerously-disable-package-manager-check"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--dry----dry-run---dry----dry-run",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--dry / --dry-run"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--env-mode-option---env-mode-option",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--env-mode <option>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#strict-strict",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "strict"
    }), " "]
  })
}, {
  depth: 4,
  url: "#loose-loose",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "loose"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--filter-string---filter-string",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--filter <string>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#用于过滤的微语法-microsyntaxes-for-filtering",
  title: _jsx(_Fragment, {
    children: "用于过滤的微语法 "
  })
}, {
  depth: 4,
  url: "#使用任务标识符-using-a-task-identifier",
  title: _jsx(_Fragment, {
    children: "使用任务标识符 "
  })
}, {
  depth: 4,
  url: "#高级过滤示例-advanced-filtering-examples",
  title: _jsx(_Fragment, {
    children: "高级过滤示例 "
  })
}, {
  depth: 3,
  url: "#--force---force",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--force"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--framework-inference---framework-inference",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--framework-inference"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--global-deps-file-glob---global-deps-file-glob",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--global-deps <file glob>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--graph-file-name---graph-file-name",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--graph <file name>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--log-order-option---log-order-option",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--log-order <option>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--log-prefix-option---log-prefix-option",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--log-prefix <option>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--no-cache---no-cache",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--no-cache"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--daemon-和---no-daemon---daemon-and---no-daemon",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--daemon"
    }), " 和 ", _jsx("code", {
      children: "--no-daemon"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--output-logs-option---output-logs-option",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--output-logs <option>"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--only---only",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--only"
    }), " "]
  })
}, {
  depth: 4,
  url: "#示例-example",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}, {
  depth: 3,
  url: "#--parallel---parallel",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--parallel"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--preflight---preflight",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--preflight"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--profile---profile",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--profile"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--remote-cache-timeout---remote-cache-timeout",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--remote-cache-timeout"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--remote-only---remote-only",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--remote-only"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--summarize---summarize",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--summarize"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--token---token",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--token"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--team---team",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--team"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--ui---ui",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--ui"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--verbosity---verbosity",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--verbosity"
    }), " "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["运行 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中指定的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Run tasks specified in ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [tasks] [options] [-- [args passed to tasks]]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["[tasks]：Turborepo 可以同时运行一个或多个任务。要通过 ", _jsx(_components.code, {
            children: "turbo"
          }), " 运行任务，必须在 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中指定该任务。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "[tasks]"
          }), ": Turborepo can run one or many tasks at the same time. To run a task through ", _jsx(_components.code, {
            children: "turbo"
          }), ", it must be specified in ", _jsx(_components.code, {
            children: "turbo.json"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["[options]：选项用于控制 ", _jsx(_components.code, {
            children: "turbo run"
          }), " 命令的行为。可用的标志选项如下所述。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "[options]"
          }), ": Options are used to control the behavior of the ", _jsx(_components.code, {
            children: "turbo run"
          }), " command. Available flag options are described below."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "[-- [传递给任务的参数]]:你也可以将参数传递给底层脚本。请注意，所有参数都将传递给运行命令中指定的所有任务。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "[-- [args passed to tasks]]"
          }), ": You may also pass arguments to the underlying scripts. Note that all arguments will be passed to all tasks that are named in the run command."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo run"
        }), " 是 ", _jsx(_components.code, {
          children: "turbo"
        }), " 的别名。", _jsx(_components.code, {
          children: "turbo run build lint check-types"
        }), " 与 ", _jsx(_components.code, {
          children: "turbo build lint check-types"
        }), " 相同。为了方便使用，我们推荐使用 ", _jsxs(_components.a, {
          href: "/docs/crafting-your-repository/constructing-ci#use-turbo-run-in-ci",
          children: ["在 CI 流水线中使用 ", _jsx(_components.code, {
            children: "turbo run"
          })]
        }), "、", _jsx(_components.code, {
          children: "turbo"
        }), " 和 ", _jsxs(_components.a, {
          href: "/docs/getting-started/installation#global-installation",
          children: ["本地全局 ", _jsx(_components.code, {
            children: "turbo"
          })]
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "turbo run"
        }), " is aliased to ", _jsx(_components.code, {
          children: "turbo"
        }), ". ", _jsx(_components.code, {
          children: "turbo run build lint check-types"
        }), " is the\nsame as ", _jsx(_components.code, {
          children: "turbo build lint check-types"
        }), ". We recommend ", _jsxs(_components.a, {
          href: "/docs/crafting-your-repository/constructing-ci#use-turbo-run-in-ci",
          children: ["using ", _jsx(_components.code, {
            children: "turbo run"
          }), " in CI\npipelines"]
        }), "\nand ", _jsx(_components.code, {
          children: "turbo"
        }), " with ", _jsxs(_components.a, {
          href: "/docs/getting-started/installation#global-installation",
          children: ["global ", _jsx(_components.code, {
            children: "turbo"
          }), "\nlocally"]
        }), " for ease of\nuse."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["如果没有提供任何任务，", _jsx(_components.code, {
        children: "turbo"
      }), " 将显示存储库中包可用的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If no tasks are provided, ", _jsx(_components.code, {
        children: "turbo"
      }), " will display what tasks are available for the packages in the repository."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "选项-options",
      children: "选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Options"
    }), "\n", _jsxs(_components.h3, {
      id: "--affected---affected",
      children: [_jsx(_components.code, {
        children: "--affected"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "仅过滤受当前分支更改影响的包。"
    }), "\n", _jsx(_components.p, {
      children: "¥Filter to only packages that are affected by changes on the current branch."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["默认情况下，该标志等效于 ", _jsx(_components.code, {
        children: "--filter=...[main...HEAD]"
      }), "。这从 Git 的角度考虑了 ", _jsx(_components.code, {
        children: "main"
      }), " 和 ", _jsx(_components.code, {
        children: "HEAD"
      }), " 之间的变化。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥By default, the flag is equivalent to ", _jsx(_components.code, {
        children: "--filter=...[main...HEAD]"
      }), ". This considers changes between ", _jsx(_components.code, {
        children: "main"
      }), " and ", _jsx(_components.code, {
        children: "HEAD"
      }), " from Git's perspective."]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsx(_components.p, {
        children: "比较需要 base 和 head 之间的所有内容都存在于签出中。如果检出范围太浅，则所有包都将被视为已更改。"
      }), _jsx(_components.p, {
        children: "¥The comparison requires everything between base and head to exist in the\ncheckout. If the checkout is too shallow, then all packages will be considered\nchanged."
      }), _jsxs(_components.p, {
        children: ["例如，设置 Git 使用 ", _jsx(_components.code, {
          children: "--filter=blob:none --depth=0"
        }), " 签出将确保 ", _jsx(_components.code, {
          children: "--affected"
        }), " 具有正确的历史记录以正常工作。"]
      }), _jsxs(_components.p, {
        children: ["¥For example, setting up Git to check out with ", _jsx(_components.code, {
          children: "--filter=blob:none --depth=0"
        }), " will ensure ", _jsx(_components.code, {
          children: "--affected"
        }), " has the right history to work correctly."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["你可以使用各自的 ", _jsx(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: "系统环境变量"
      }), " 覆盖默认基础包和头包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can override the default base and head with their respective ", _jsx(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: "System Environment Variables"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Override Git comparison base"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "TURBO_SCM_BASE"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "development"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Override Git comparison head"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "TURBO_SCM_HEAD"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "your-branch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--cache-options---cache-options",
      children: [_jsx(_components.code, {
        children: "--cache <options>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "local:rw,remote:rw"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "local:rw,remote:rw"
      })]
    }), "\n", _jsx(_components.p, {
      children: "指定运行的缓存源。接受以逗号分隔的选项列表："
    }), "\n", _jsx(_components.p, {
      children: "¥Specify caching sources for the run. Accepts a comma-separated list of options:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "local"
          }), "：使用本地文件系统缓存"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "local"
          }), ": Use the local filesystem cache"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "remote"
          }), "：使用远程缓存"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "remote"
          }), ": Use the Remote Cache"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "当省略缓存源时，读取和写入都将被禁用。"
    }), "\n", _jsx(_components.p, {
      children: "¥When a caching source is omitted, reading and writing are both disabled."
    }), "\n", _jsx(_components.p, {
      children: "缓存源使用以下值："
    }), "\n", _jsx(_components.p, {
      children: "¥Cache sources use the following values:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "rw"
          }), "：阅读并写入"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "rw"
          }), ": Read and write"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "r"
          }), "：只读"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "r"
          }), ": Read only"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "w"
          }), "：只写"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "w"
          }), ": Write only"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["无 (", _jsx(_components.code, {
            children: "local:"
          }), ")：不使用缓存。相当于省略缓存源选项。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥None (", _jsx(_components.code, {
            children: "local:"
          }), ") : Does not use cache. Equivalent to omitting the cache source option."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Read from and write to local cache. Only read from Remote Cache."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:rw,remote:r"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Only read from local cache. Read from and write to Remote Cache."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:r,remote:rw"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Read from and write to local cache. No Remote Cache activity."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:rw"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Do not use local cache. Only read from Remote Cache."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:,remote:r"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--cache-dir-path---cache-dir-path",
      children: [_jsx(_components.code, {
        children: "--cache-dir <path>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: ".turbo/cache"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: ".turbo/cache"
      })]
    }), "\n", _jsx(_components.p, {
      children: "指定文件系统缓存目录。"
    }), "\n", _jsx(_components.p, {
      children: "¥Specify the filesystem cache directory."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache-dir="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"./my-cache\""
            })]
          })
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsxs(_components.p, {
        children: ["更改目录时，请确保该目录位于你的 ", _jsx(_components.code, {
          children: ".gitignore"
        }), " 中。"]
      }), _jsxs(_components.p, {
        children: ["¥Ensure the directory is in your ", _jsx(_components.code, {
          children: ".gitignore"
        }), " when changing it."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["也可以通过 ", _jsx(_components.code, {
        children: "TURBO_CACHE_DIR=example/path"
      }), " 系统变量设置相同的行为。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The same behavior can also be set via the ", _jsx(_components.code, {
        children: "TURBO_CACHE_DIR=example/path"
      }), " system variable."]
    }), "\n", _jsxs(_components.h3, {
      id: "--concurrency-number--percentage---concurrency-number--percentage",
      children: [_jsx(_components.code, {
        children: "--concurrency <number | percentage>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "10"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "10"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["设置/限制任务执行的最大并发数。必须是大于或等于 ", _jsx(_components.code, {
        children: "1"
      }), " 的整数，或者像 ", _jsx(_components.code, {
        children: "50%"
      }), " 这样的百分比值。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Set/limit the maximum concurrency for task execution. Must be an integer greater than or equal to ", _jsx(_components.code, {
        children: "1"
      }), " or a percentage value like ", _jsx(_components.code, {
        children: "50%"
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.code, {
            children: "1"
          }), " 强制串行执行（一次执行一个任务）。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Use ", _jsx(_components.code, {
            children: "1"
          }), " to force serial execution (one task at a time)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.code, {
            children: "100%"
          }), " 使用所有可用的逻辑处理器。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Use ", _jsx(_components.code, {
            children: "100%"
          }), " to use all available logical processors."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果同时传递了 ", _jsx(_components.a, {
            href: "#--parallel",
            children: _jsx(_components.code, {
              children: "--parallel"
            })
          }), " 标志，则此选项将被忽略。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥This option is ignored if the ", _jsx(_components.a, {
            href: "#--parallel",
            children: _jsx(_components.code, {
              children: "--parallel"
            })
          }), " flag is also passed."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --concurrency=50%"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --concurrency=5"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--continueoption---continueoption",
      children: [_jsx(_components.code, {
        children: "--continue[=<option>]"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "never"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "never"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["指定 ", _jsx(_components.code, {
        children: "turbo"
      }), " 在出现错误（例如，任务的退出代码为非零）时应如何处理当前和待处理的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Specify how ", _jsx(_components.code, {
        children: "turbo"
      }), " should handle current and pending tasks in the presence of an error (e.g. non-zero exit code from a task)."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["当 ", _jsx(_components.code, {
            children: "--continue=never"
          }), " 发生错误时，", _jsx(_components.code, {
            children: "turbo"
          }), " 将取消所有任务。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥When ", _jsx(_components.code, {
            children: "--continue=never"
          }), " and an error occurs, ", _jsx(_components.code, {
            children: "turbo"
          }), " will cancel all tasks."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["当 ", _jsx(_components.code, {
            children: "--continue=dependencies-successful"
          }), " 发生错误时，", _jsx(_components.code, {
            children: "turbo"
          }), " 将取消依赖任务。依赖已成功的任务将继续运行。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥When ", _jsx(_components.code, {
            children: "--continue=dependencies-successful"
          }), " and an error occurs, ", _jsx(_components.code, {
            children: "turbo"
          }), " will cancel dependent tasks. Tasks whose dependencies have succeeded will continue to run."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["当 ", _jsx(_components.code, {
            children: "--continue=always"
          }), " 发生错误时，", _jsx(_components.code, {
            children: "turbo"
          }), " 将继续运行所有任务，即使是依赖失败的任务。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥When ", _jsx(_components.code, {
            children: "--continue=always"
          }), " and an error occurs, ", _jsx(_components.code, {
            children: "turbo"
          }), " will continue running all tasks, even those whose dependencies have failed."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["当 ", _jsx(_components.code, {
            children: "--continue"
          }), " 未指定值时，它将默认为 ", _jsx(_components.code, {
            children: "always"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥When ", _jsx(_components.code, {
            children: "--continue"
          }), " is specified without a value, it will default to ", _jsx(_components.code, {
            children: "always"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["在所有情况下，", _jsx(_components.code, {
        children: "turbo"
      }), " 都将以执行期间遇到的最高退出代码值退出。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In all cases, ", _jsx(_components.code, {
        children: "turbo"
      }), " will exit with the highest exit code value encountered during execution."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --continue"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--cwd-path---cwd-path",
      children: [_jsx(_components.code, {
        children: "--cwd <path>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：根目录 ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: Directory of root ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsx(_components.p, {
      children: "设置命令的工作目录。"
    }), "\n", _jsx(_components.p, {
      children: "¥Set the working directory of the command."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cwd=./somewhere/else/in/your/repo"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--dangerously-disable-package-manager-check---dangerously-disable-package-manager-check",
      children: [_jsx(_components.code, {
        children: "--dangerously-disable-package-manager-check"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 使用你仓库的锁文件来确定缓存行为、", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages",
        children: "软件包图表"
      }), " 等。因此，我们使用 ", _jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#packagemanager",
        children: [_jsx(_components.code, {
          children: "packageManager"
        }), " 字段"]
      }), " 来帮助你稳定 Turborepo。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo uses your repository's lockfile to determine caching behavior, ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages",
        children: "Package Graphs"
      }), ", and more. Because of this, we use ", _jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#packagemanager",
        children: ["the ", _jsx(_components.code, {
          children: "packageManager"
        }), " field"]
      }), " to help you stabilize your Turborepo."]
    }), "\n", _jsxs(_components.p, {
      children: ["为了帮助增量迁移或在无法使用 ", _jsx(_components.code, {
        children: "packageManager"
      }), " 字段的情况下，你可以使用 ", _jsx(_components.code, {
        children: "--dangerously-disable-package-manager-check"
      }), " 退出此检查，并承担不稳定的锁文件产生不可预测行为的风险。禁用后，Turborepo 将尽力查找适用于该存储库的包管理器。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To help with incremental migration or in situations where you cannot use the ", _jsx(_components.code, {
        children: "packageManager"
      }), " field, you may use ", _jsx(_components.code, {
        children: "--dangerously-disable-package-manager-check"
      }), " to opt out of this check and assume the risks of unstable lockfiles producing unpredictable behavior. When disabled, Turborepo will attempt a best-effort discovery of the intended package manager meant for the repository."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["你也可以使用 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#dangerouslydisablepacakgemanagercheck",
          children: [_jsx(_components.code, {
            children: "turbo.json"
          }), " 中的配置"]
        }), " 或 ", _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: _jsx(_components.code, {
            children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
          })
        }), " 环境变量退出此检查，以获得更广泛的覆盖范围。"]
      }), _jsxs(_components.p, {
        children: ["¥You may also opt out of this check using ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#dangerouslydisablepacakgemanagercheck",
          children: ["configuration in\n", _jsx(_components.code, {
            children: "turbo.json"
          })]
        }), "\nor the\n", _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: _jsx(_components.code, {
            children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
          })
        }), "\nenvironment variable for broader coverage."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--dry----dry-run---dry----dry-run",
      children: [_jsx(_components.code, {
        children: "--dry / --dry-run"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "显示将要运行的包和任务的详细信息，而不是执行任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥Instead of executing tasks, display details about the packages and tasks that would be run."
    }), "\n", _jsxs(_components.p, {
      children: ["指定 ", _jsx(_components.code, {
        children: "--dry=json"
      }), " 以获取 JSON 格式的输出。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Specify ", _jsx(_components.code, {
        children: "--dry=json"
      }), " to get the output in JSON format."]
    }), "\n", _jsx(_components.p, {
      children: "任务详细信息包含以下有用信息（列表并非详尽）："
    }), "\n", _jsx(_components.p, {
      children: "¥Task details include useful information like (list is non-exhaustive):"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "字段"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "taskId"
            })
          }), _jsxs(_components.td, {
            children: ["任务 ID，格式为 ", _jsx(_components.code, {
              children: "package-name#task-name"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "task"
            })
          }), _jsx(_components.td, {
            children: "要执行的任务名称"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "package"
            })
          }), _jsx(_components.td, {
            children: "运行任务的包"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hash"
            })
          }), _jsx(_components.td, {
            children: "任务的哈希值（用于缓存）"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hashOfExternalDependencies"
            })
          }), _jsx(_components.td, {
            children: "全局哈希值"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "command"
            })
          }), _jsx(_components.td, {
            children: "用于运行任务的命令"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "inputs"
            })
          }), _jsx(_components.td, {
            children: "用于哈希计算的文件输入列表"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "outputs"
            })
          }), _jsx(_components.td, {
            children: "已缓存的文件输出列表"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dependencies"
            })
          }), _jsx(_components.td, {
            children: "必须在此任务之前运行的任务"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dependents"
            })
          }), _jsx(_components.td, {
            children: "必须在此任务之后运行的任务"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "environmentVariables"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "env"
            }), " 和 ", _jsx(_components.code, {
              children: "passThroughEnv"
            }), " 中指定的环境变量列表"]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--env-mode-option---env-mode-option",
      children: [_jsx(_components.code, {
        children: "--env-mode <option>"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.code, {
        children: "type: string"
      })
    }), "\n", _jsx(_components.p, {
      children: "控制任务运行时可用的环境变量。"
    }), "\n", _jsx(_components.p, {
      children: "¥Controls the available environment variables in the task's runtime."
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "PATH"
        }), "、", _jsx(_components.code, {
          children: "SHELL"
        }), " 和 ", _jsx(_components.code, {
          children: "SYSTEMROOT"
        }), " 始终可用于该任务。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "PATH"
        }), ", ", _jsx(_components.code, {
          children: "SHELL"
        }), ", and ", _jsx(_components.code, {
          children: "SYSTEMROOT"
        }), " are always available to the task."]
      })]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "option"
          }), _jsx(_components.th, {
            children: "description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "#strict",
              children: "strict"
            }), "(默认)"]
          }), _jsx(_components.td, {
            children: "仅允许明确列出的环境变量可用"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "#loose",
              children: "loose"
            })
          }), _jsx(_components.td, {
            children: "允许所有环境变量可用"
          })]
        })]
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --env-mode=loose"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["也可以通过 ", _jsx(_components.code, {
        children: "TURBO_ENV_MODE=strict"
      }), " 系统变量设置相同的行为。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The same behavior can also be set via the ", _jsx(_components.code, {
        children: "TURBO_ENV_MODE=strict"
      }), " system variable."]
    }), "\n", _jsxs(_components.h4, {
      id: "strict-strict",
      children: [_jsx(_components.code, {
        children: "strict"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "只有以下键中指定的环境变量才可用于任务："
    }), "\n", _jsx(_components.p, {
      children: "¥Only environment variables specified in the following keys are\navailable to the task:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/reference/configuration#env",
            children: _jsx(_components.code, {
              children: "env"
            })
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/reference/configuration#passthroughenv",
            children: _jsx(_components.code, {
              children: "passThroughEnv"
            })
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/reference/configuration#globalenv",
            children: _jsx(_components.code, {
              children: "globalEnv"
            })
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/reference/configuration#globalpassthroughenv",
            children: _jsx(_components.code, {
              children: "globalPassThroughEnv"
            })
          })
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["如果指定或推断了严格模式，则所有任务都将以 ", _jsx(_components.code, {
        children: "strict"
      }), " 模式运行，无论其配置如何。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If Strict Mode is specified or inferred, ", _jsx(_components.strong, {
        children: "all"
      }), " tasks are run in ", _jsx(_components.code, {
        children: "strict"
      }), " mode,\nregardless of their configuration."]
    }), "\n", _jsxs(_components.h4, {
      id: "loose-loose",
      children: [_jsx(_components.code, {
        children: "loose"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "计算机上的所有环境变量都可供任务运行时使用。"
    }), "\n", _jsx(_components.p, {
      children: "¥All environment variables on the machine are made available to the task's runtime."
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsxs(_components.p, {
        children: ["当环境变量未包含在上述 ", _jsx(_components.code, {
          children: "strict"
        }), " 中列出的键的缓存中时，这可能很危险。在 ", _jsx(_components.code, {
          children: "loose"
        }), " 模式下，你更有可能从缓存中恢复包含错误环境变量的包版本。"]
      }), _jsxs(_components.p, {
        children: ["¥This can be dangerous when environment variables are not accounted for in\ncaching with the keys listed in ", _jsx(_components.code, {
          children: "strict"
        }), " above. You're much more likely to\nrestore a version of your package with wrong environment variables from cache\nin ", _jsx(_components.code, {
          children: "loose"
        }), " mode."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--filter-string---filter-string",
      children: [_jsx(_components.code, {
        children: "--filter <string>"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "从你的代码库图中指定要执行的目标。可以组合多个过滤器来选择不同的目标集。"
    }), "\n", _jsx(_components.p, {
      children: "¥Specify targets to execute from your repository's graph. Multiple filters can be combined to select distinct sets of targets."
    }), "\n", _jsx(_components.p, {
      children: "可以组合使用过滤器来创建包、目录和 Git 提交的组合。"
    }), "\n", _jsx(_components.p, {
      children: "¥Filters can be combined to create combinations of packages, directories, and git commits."
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "目标类型"
          }), _jsx(_components.th, {
            children: "描述"
          }), _jsx(_components.th, {
            children: "示例"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "包"
          }), _jsxs(_components.td, {
            children: ["在 ", _jsx(_components.code, {
              children: "package.json"
            }), " 中按名称选择一个包。"]
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "turbo run build --filter=ui"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "目录"
          }), _jsxs(_components.td, {
            children: ["指定用于捕获要运行任务的软件包列表的目录。与其他过滤器一起使用时，必须包含在 ", _jsx(_components.code, {
              children: "{}"
            }), " 中。"]
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "turbo run build --filter=./apps/*"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Git 提交"
          }), _jsxs(_components.td, {
            children: ["使用 Git 说明符，指定包含源代码控制更改的包。必须包含在 ", _jsx(_components.code, {
              children: "[]"
            }), " 中。"]
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "turbo run build --filter=[HEAD^1]"
            })
          })]
        })]
      })]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsx(_components.code, {
        children: "-F"
      }), " is an alias for ", _jsx(_components.code, {
        children: "--filter"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "用于过滤的微语法-microsyntaxes-for-filtering",
      children: "用于过滤的微语法 "
    }), "\n", _jsx(_components.p, {
      children: "¥Microsyntaxes for filtering"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "!"
          }), "：从选择中取反目标。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "!"
          }), ": Negate targets from the selection."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "..."
          }), " 使用包：选择 ", _jsx(_components.a, {
            href: "/docs/core-concepts/package-and-task-graph#package-graph",
            children: "软件包图表"
          }), " 中相对于目标的所有包。在包名称前使用 ", _jsx(_components.code, {
            children: "..."
          }), " 将选择目标的依赖，而在包名称后使用 ", _jsx(_components.code, {
            children: "..."
          }), " 将选择目标的依赖。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "..."
          }), " using packages: Select all packages in the ", _jsx(_components.a, {
            href: "/docs/core-concepts/package-and-task-graph#package-graph",
            children: "Package Graph"
          }), " relative to the target. Using ", _jsx(_components.code, {
            children: "..."
          }), " ", _jsx(_components.strong, {
            children: "before"
          }), " the package name will select ", _jsx(_components.strong, {
            children: "dependents"
          }), " of the target while using ", _jsx(_components.code, {
            children: "..."
          }), " ", _jsx(_components.strong, {
            children: "after"
          }), " the package name will select ", _jsx(_components.strong, {
            children: "dependencies"
          }), " of the target."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "..."
          }), " 使用 Git 提交：使用 ", _jsx(_components.code, {
            children: "[<from commit>]...[<to commit>]"
          }), " 选择一个范围。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "..."
          }), " using Git commits: Select a range using ", _jsx(_components.code, {
            children: "[<from commit>]...[<to commit>]"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "^"
          }), "：使用 ", _jsx(_components.code, {
            children: "..."
          }), " 时，请从选择中省略目标。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "^"
          }), ": Omit the target from the selection when using ", _jsx(_components.code, {
            children: "..."
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["有关过滤的深入讨论和实际用例，请访问 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "正在运行的任务页面"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For in-depth discussion and practical use cases of filtering, visit ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "the Running Tasks page"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "使用任务标识符-using-a-task-identifier",
      children: "使用任务标识符 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using a task identifier"
    }), "\n", _jsxs(_components.p, {
      children: ["你还可以以 ", _jsx(_components.code, {
        children: "package-name#task-name"
      }), " 的格式为特定包运行特定任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also run a specific task for a specific package in the format of ", _jsx(_components.code, {
        children: "package-name#task-name"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web#lint"
            })]
          })
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["这还将运行任务的依赖。要运行不包含依赖的任务，请使用 ", _jsxs(_components.a, {
          href: "#--only",
          children: [_jsx(_components.code, {
            children: "--only"
          }), " 标志"]
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥This will also run the task's dependencies. To run a task without its\ndependencies, use ", _jsxs(_components.a, {
          href: "#--only",
          children: ["the ", _jsx(_components.code, {
            children: "--only"
          }), " flag"]
        }), "."]
      })]
    }), "\n", _jsx(_components.h4, {
      id: "高级过滤示例-advanced-filtering-examples",
      children: "高级过滤示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Advanced filtering examples"
    }), "\n", _jsx(_components.p, {
      children: "你可以组合多个过滤器以进一步优化你的目标。多个过滤器组合成一个联合体，取反的过滤器会从联合体的结果中删除相应的包。"
    }), "\n", _jsx(_components.p, {
      children: "¥You can combine multiple filters to further refine your targets. Multiple filters are combined as a union, with negated filters removing packages from the result of the union."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Any packages in `apps` subdirectories that have changed since the last commit"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".apps/*}[HEAD^1]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Any packages in `apps` subdirectories except ./apps/admin"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=./apps/"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "*"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=!./apps/admin"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Run the build task for the docs and web packages"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=docs"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=web"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Build everything that depends on changes in branch 'my-feature'"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=...[origin/my-feature]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Build everything that depends on changes between two Git SHAs"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=[a1b2c3d...e4f5g6h]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Build '@acme/ui' if:"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# - It or any of its dependencies have changed since the previous commit"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@acme/ui...[HEAD^1]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Test each package that is:"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# - In the '@acme' scope"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# - Or, in the 'packages' directory"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# - Or, changed since the previous commit"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@acme/"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "*"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "./packages/*}[HEAD^1]"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--force---force",
      children: [_jsx(_components.code, {
        children: "--force"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "忽略现有的缓存文件并重新执行所有任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥Ignore existing cached artifacts and re-execute all tasks."
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "--force"
        }), " 将覆盖现有的任务缓存。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "--force"
        }), " will overwrite existing task caches."]
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --force"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["也可以通过 ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: [_jsx(_components.code, {
          children: "TURBO_FORCE"
        }), " 环境变量"]
      }), " 设置相同的行为。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The same behavior can also be set via ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: ["the ", _jsx(_components.code, {
          children: "TURBO_FORCE"
        }), " environment variable"]
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "--framework-inference---framework-inference",
      children: [_jsx(_components.code, {
        children: "--framework-inference"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["指定是否对任务执行 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
        children: "框架推断"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Specify whether or not to do ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
        children: "Framework Inference"
      }), " for tasks."]
    }), "\n", _jsxs(_components.p, {
      children: ["当 ", _jsx(_components.code, {
        children: "false"
      }), " 匹配时，", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
        children: "自动环境变量包含"
      }), " 被禁用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When ", _jsx(_components.code, {
        children: "false"
      }), ", ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
        children: "automatic environment variable inclusion"
      }), " is disabled."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --framework-inference=false"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--global-deps-file-glob---global-deps-file-glob",
      children: [_jsx(_components.code, {
        children: "--global-deps <file glob>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["指定要进行哈希处理的全局文件系统依赖。适用于 ", _jsx(_components.code, {
        children: ".env"
      }), " 以及根目录中影响多个包的文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Specify glob of global filesystem dependencies to be hashed. Useful for ", _jsx(_components.code, {
        children: ".env"
      }), " and files in the root directory that impact multiple packages."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --global-deps="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --global-deps="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env.*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --global-deps="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".eslintrc\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --global-deps="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"jest.config.ts\""
            })]
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["我们建议在 ", _jsx(_components.code, {
          children: "turbo.json"
        }), " 中指定你想要在 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#globaldeps",
          children: [_jsx(_components.code, {
            children: "globalDependencies"
          }), " 键"]
        }), " 中包含哈希值的文件全局变量，以确保它们始终被考虑在内。"]
      }), _jsxs(_components.p, {
        children: ["¥We recommend specifying file globs that you'd like to include your hashes in\n", _jsxs(_components.a, {
          href: "/docs/reference/configuration#globaldeps",
          children: ["the ", _jsx(_components.code, {
            children: "globalDependencies"
          }), " key"]
        }), " in\n", _jsx(_components.code, {
          children: "turbo.json"
        }), " to make sure they are always accounted for."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--graph-file-name---graph-file-name",
      children: [_jsx(_components.code, {
        children: "--graph <file name>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "dot"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "dot"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["此命令可以输出一个图文件：", _jsx(_components.code, {
        children: "svg"
      }), "、", _jsx(_components.code, {
        children: "png"
      }), "、", _jsx(_components.code, {
        children: "jpg"
      }), "、", _jsx(_components.code, {
        children: "pdf"
      }), "、", _jsx(_components.code, {
        children: "json"
      }), "、", _jsx(_components.code, {
        children: "html"
      }), "、", _jsx(_components.code, {
        children: "mermaid"
      }), " 或 ", _jsx(_components.code, {
        children: "dot"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This command can output a graph file: ", _jsx(_components.code, {
        children: "svg"
      }), ", ", _jsx(_components.code, {
        children: "png"
      }), ", ", _jsx(_components.code, {
        children: "jpg"
      }), ", ", _jsx(_components.code, {
        children: "pdf"
      }), ", ", _jsx(_components.code, {
        children: "json"
      }), ", ", _jsx(_components.code, {
        children: "html"
      }), ", ", _jsx(_components.code, {
        children: "mermaid"
      }), ", or ", _jsx(_components.code, {
        children: "dot"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果未安装 ", _jsx(_components.a, {
        href: "https://graphviz.org/",
        children: "Graphviz"
      }), " 或未提供文件名，此命令会将点图打印到 ", _jsx(_components.code, {
        children: "stdout"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If ", _jsx(_components.a, {
        href: "https://graphviz.org/",
        children: "Graphviz"
      }), " is not installed, or no filename is provided, this command prints the dot graph to ", _jsx(_components.code, {
        children: "stdout"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --graph"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --graph=my-graph.svg"
            })]
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsx(_components.p, {
        children: "已知 Bug：所有可能的任务节点都将立即添加到图中，即使该脚本实际上并不存在于给定包中。这不会影响执行，但图表可能会夸大所涉及的包和任务的数量。"
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.strong, {
          children: "Known Bug"
        }), ": All possible task nodes will be added to the graph at the\nmoment, even if that script does not actually exist in a given package. This\nhas no impact on execution, but the graph may overstate the number of packages\nand tasks involved."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--log-order-option---log-order-option",
      children: [_jsx(_components.code, {
        children: "--log-order <option>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "auto"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "auto"
      })]
    }), "\n", _jsx(_components.p, {
      children: "设置日志输出的顺序。"
    }), "\n", _jsx(_components.p, {
      children: "¥Set the ordering for log output."
    }), "\n", _jsxs(_components.p, {
      children: ["默认情况下，", _jsx(_components.code, {
        children: "turbo"
      }), " 将在 CI 环境中使用 ", _jsx(_components.code, {
        children: "grouped"
      }), " 日志，在其他地方使用 ", _jsx(_components.code, {
        children: "stream"
      }), " 日志。使用 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/reference/configuration#ui",
        children: "终端 UI"
      }), " 时，此标志不适用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥By default, ", _jsx(_components.code, {
        children: "turbo"
      }), " will use ", _jsx(_components.code, {
        children: "grouped"
      }), " logs in CI environments and ", _jsx(_components.code, {
        children: "stream"
      }), " logs everywhere else. This flag is not applicable when using ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/reference/configuration#ui",
        children: "the terminal UI"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --log-order=stream"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "选项"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "stream"
            })
          }), _jsx(_components.td, {
            children: "输出可用后立即显示"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "grouped"
            })
          }), _jsx(_components.td, {
            children: "按任务分组输出"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "auto"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "turbo"
            }), " 根据自身的启发式方法进行决策"]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--log-prefix-option---log-prefix-option",
      children: [_jsx(_components.code, {
        children: "--log-prefix <option>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "auto"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "auto"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["控制运行任务时生成的日志行的 ", _jsx(_components.code, {
        children: "<package>:<task>:"
      }), " 前缀。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Control the ", _jsx(_components.code, {
        children: "<package>:<task>:"
      }), " prefix for log lines produced when running tasks."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --log-prefix=none"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "选项"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "task"
            })
          }), _jsxs(_components.td, {
            children: ["强制在日志中添加 ", _jsx(_components.code, {
              children: "<package>:<task>:"
            }), " 前缀"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "none"
            })
          }), _jsx(_components.td, {
            children: "不支持前缀"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "auto"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "turbo"
            }), " 根据自身的启发式方法进行决策"]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--no-cache---no-cache",
      children: [_jsx(_components.code, {
        children: "--no-cache"
      }), " "]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      title: "Deprecated",
      children: [_jsxs(_components.p, {
        children: ["此标志已弃用，并将在未来的主要版本中移除。请改用 ", _jsx(_components.a, {
          href: "#--cache-options",
          children: _jsx(_components.code, {
            children: "--cache"
          })
        }), " 标志。"]
      }), _jsxs(_components.p, {
        children: ["¥This flag is deprecated and will be removed in a future major release. Please\nuse the ", _jsx(_components.a, {
          href: "#--cache-options",
          children: _jsx(_components.code, {
            children: "--cache"
          })
        }), " flag instead."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["默认 ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "不要缓存任务结果。"
    }), "\n", _jsx(_components.p, {
      children: "¥Do not cache results of the task."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --no-cache"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--daemon-和---no-daemon---daemon-and---no-daemon",
      children: [_jsx(_components.code, {
        children: "--daemon"
      }), " 和 ", _jsx(_components.code, {
        children: "--no-daemon"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "--daemon"
      }), " and ", _jsx(_components.code, {
        children: "--no-daemon"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 可以运行后台进程，预先计算用于确定需要完成的工作的值。此独立进程（守护进程）是一种优化，并非 ", _jsx(_components.code, {
        children: "turbo"
      }), " 正常运行所必需的。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo"
      }), " can run a background process to pre-calculate values used for determining work that needs to be done. This standalone process (daemon) is an optimization, and not required for proper functioning of ", _jsx(_components.code, {
        children: "turbo"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["使用 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#daemon",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " 中的 ", _jsx(_components.code, {
          children: "daemon"
        }), " 字段"]
      }), " 为你的存储库设置默认守护进程用法。传递 ", _jsx(_components.code, {
        children: "--daemon"
      }), " 要求 ", _jsx(_components.code, {
        children: "turbo"
      }), " 使用独立进程，而 ", _jsx(_components.code, {
        children: "--no-daemon"
      }), " 指示 ", _jsx(_components.code, {
        children: "turbo"
      }), " 避免使用或创建独立进程。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The default daemon usage is set for your repository using ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#daemon",
        children: ["the ", _jsx(_components.code, {
          children: "daemon"
        }), " field in ", _jsx(_components.code, {
          children: "turbo.json"
        })]
      }), ". Passing ", _jsx(_components.code, {
        children: "--daemon"
      }), " requires ", _jsx(_components.code, {
        children: "turbo"
      }), " to use the standalone process, while ", _jsx(_components.code, {
        children: "--no-daemon"
      }), " instructs ", _jsx(_components.code, {
        children: "turbo"
      }), " to avoid using or creating the standalone process."]
    }), "\n", _jsxs(_components.p, {
      children: ["也可以通过 ", _jsx(_components.code, {
        children: "TURBO_DAEMON=true"
      }), " 系统变量设置相同的行为。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The same behavior can also be set via the ", _jsx(_components.code, {
        children: "TURBO_DAEMON=true"
      }), " system variable."]
    }), "\n", _jsxs(_components.h3, {
      id: "--output-logs-option---output-logs-option",
      children: [_jsx(_components.code, {
        children: "--output-logs <option>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "full"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "full"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["设置输出日志类型，如果 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中已定义，则覆盖 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputlogs",
        children: _jsx(_components.code, {
          children: "outputLogs"
        })
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Set type of output logging, overriding ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputlogs",
        children: _jsx(_components.code, {
          children: "outputLogs"
        })
      }), " if it's defined in ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --output-logs=errors-only"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "选项"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "full"
            })
          }), _jsx(_components.td, {
            children: "显示所有日志"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hash-only"
            })
          }), _jsx(_components.td, {
            children: "仅显示任务的哈希值"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "new-only"
            })
          }), _jsx(_components.td, {
            children: "仅显示缓存未命中的日志"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "errors-only"
            })
          }), _jsx(_components.td, {
            children: "仅显示任务失败的日志"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "none"
            })
          }), _jsx(_components.td, {
            children: "隐藏所有任务日志"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--only---only",
      children: [_jsx(_components.code, {
        children: "--only"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "限制执行仅包含指定的任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥Restricts execution to include specified tasks only."
    }), "\n", _jsx(_components.h4, {
      id: "示例-example",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Example"
    }), "\n", _jsxs(_components.p, {
      children: ["给定以下 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Given this ", _jsx(_components.code, {
        children: "turbo.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turbo.nodejs.cn/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --only"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["该命令将仅执行每个包中的 ", _jsx(_components.code, {
        children: "test"
      }), " 任务。它不会运行 ", _jsx(_components.code, {
        children: "build"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The command will ", _jsx(_components.em, {
        children: "only"
      }), " execute the ", _jsx(_components.code, {
        children: "test"
      }), " tasks in each package. It will not run ", _jsx(_components.code, {
        children: "build"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["此外，", _jsx(_components.code, {
        children: "--only"
      }), " 将仅运行指定包中的任务，不包括依赖。例如，", _jsx(_components.code, {
        children: "turbo run build --filter=web --only"
      }), " 将仅运行 ", _jsx(_components.code, {
        children: "web"
      }), " 包中的 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Additionally, ", _jsx(_components.code, {
        children: "--only"
      }), " will only run tasks in specified packages, excluding dependencies. For example, ", _jsx(_components.code, {
        children: "turbo run build --filter=web --only"
      }), ", will ", _jsx(_components.strong, {
        children: "only"
      }), " run the ", _jsx(_components.code, {
        children: "build"
      }), " script in the ", _jsx(_components.code, {
        children: "web"
      }), " package."]
    }), "\n", _jsxs(_components.h3, {
      id: "--parallel---parallel",
      children: [_jsx(_components.code, {
        children: "--parallel"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "在包之间并行运行命令，忽略任务依赖图。"
    }), "\n", _jsx(_components.p, {
      children: "¥Run commands in parallel across packages, ignoring the task dependency graph."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --parallel"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --parallel"
            })]
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "--parallel"
        }), " 标志通常用于长时间运行且不会退出的 \"dev\" 或 \"watch\" 任务。从 ", _jsx(_components.code, {
          children: "turbo@1.7"
        }), " 开始，我们建议改用 ", _jsx(_components.a, {
          href: "/docs/reference/configuration#persistent",
          children: _jsx(_components.code, {
            children: "persistent"
          })
        }), " 配置这些任务。"]
      }), _jsxs(_components.p, {
        children: ["¥The ", _jsx(_components.code, {
          children: "--parallel"
        }), " flag is typically used for long-running \"dev\" or \"watch\"\ntasks that don't exit. Starting in ", _jsx(_components.code, {
          children: "turbo@1.7"
        }), ", we recommend configuring these\ntasks using ", _jsx(_components.a, {
          href: "/docs/reference/configuration#persistent",
          children: _jsx(_components.code, {
            children: "persistent"
          })
        }), " instead."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--preflight---preflight",
      children: [_jsx(_components.code, {
        children: "--preflight"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "仅在配置了远程缓存时适用。允许在每个缓存工件和分析请求之前发送预检请求。后续的上传和下载将遵循重定向。"
    }), "\n", _jsx(_components.p, {
      children: "¥Only applicable when Remote Caching is configured. Enables sending a preflight request before every cache artifact and analytics request. The follow-up upload and download will follow redirects."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --preflight"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["也可以通过 ", _jsx(_components.code, {
        children: "TURBO_PREFLIGHT=true"
      }), " 系统变量设置相同的行为。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The same behavior can also be set via the ", _jsx(_components.code, {
        children: "TURBO_PREFLIGHT=true"
      }), " system variable."]
    }), "\n", _jsxs(_components.h3, {
      id: "--profile---profile",
      children: [_jsx(_components.code, {
        children: "--profile"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "以 Chrome Tracing 格式生成运行跟踪，你可以使用它来分析性能。"
    }), "\n", _jsx(_components.p, {
      children: "¥Generates a trace of the run in Chrome Tracing format that you can use to analyze performance."
    }), "\n", _jsxs(_components.p, {
      children: ["你必须使用 ", _jsx(_components.code, {
        children: "--profile"
      }), " 提供详细程度标志（", _jsx(_components.code, {
        children: "-v"
      }), "、", _jsx(_components.code, {
        children: "-vv"
      }), " 或 ", _jsx(_components.code, {
        children: "-vvv"
      }), "）才能生成跟踪。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You must provide a verbosity flag (", _jsx(_components.code, {
        children: "-v"
      }), ", ", _jsx(_components.code, {
        children: "-vv"
      }), ", or ", _jsx(_components.code, {
        children: "-vvv"
      }), ") with ", _jsx(_components.code, {
        children: "--profile"
      }), " to produce a trace."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --profile=profile.json"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -vvv"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["配置文件可以在 ", _jsx(_components.a, {
        href: "https://ui.perfetto.dev/",
        children: "Perfetto"
      }), " 等工具中查看。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Profiles can be viewed in a tool like ", _jsx(_components.a, {
        href: "https://ui.perfetto.dev/",
        children: "Perfetto"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "--remote-cache-timeout---remote-cache-timeout",
      children: [_jsx(_components.code, {
        children: "--remote-cache-timeout"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "30"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "30"
      })]
    }), "\n", _jsx(_components.p, {
      children: "设置远程缓存操作的超时时间（以秒为单位）。"
    }), "\n", _jsx(_components.p, {
      children: "¥Set the timeout for Remote Cache operations in seconds."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --remote-cache-timeout=60"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--remote-only---remote-only",
      children: [_jsx(_components.code, {
        children: "--remote-only"
      }), " "]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      title: "Deprecated",
      children: [_jsxs(_components.p, {
        children: ["此标志已弃用，并将在未来的主要版本中移除。请改用 ", _jsx(_components.a, {
          href: "#--cache-options",
          children: _jsx(_components.code, {
            children: "--cache"
          })
        }), " 标志。"]
      }), _jsxs(_components.p, {
        children: ["¥This flag is deprecated and will be removed in a future major release. Please\nuse the ", _jsx(_components.a, {
          href: "#--cache-options",
          children: _jsx(_components.code, {
            children: "--cache"
          })
        }), " flag instead."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "忽略所有任务的本地文件系统缓存，使用远程缓存读取和缓存任务输出。"
    }), "\n", _jsx(_components.p, {
      children: "¥Ignore the local filesystem cache for all tasks, using Remote Cache for reading and caching task outputs."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --remote-only"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--summarize---summarize",
      children: [_jsx(_components.code, {
        children: "--summarize"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.code, {
        children: ".turbo/runs"
      }), " 中生成一个包含运行元数据的 JSON 文件，其中包括："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Generates a JSON file in ", _jsx(_components.code, {
        children: ".turbo/runs"
      }), " containing metadata about the run, including:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "受影响的软件包"
        }), "\n", _jsx(_components.p, {
          children: "¥Affected packages"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "已执行的任务（包括其时间和哈希值）"
        }), "\n", _jsx(_components.p, {
          children: "¥Executed tasks (including their timings and hashes)"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "缓存的 artifact 中包含的所有文件"
        }), "\n", _jsx(_components.p, {
          children: "¥All the files included in the cached artifact"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --summarize"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "此标志有助于调试以确定以下事项："
    }), "\n", _jsx(_components.p, {
      children: "¥This flag can be helpful for debugging to determine things like:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo"
          }), " 如何解释 ", _jsx(_components.code, {
            children: "inputs"
          }), " 和 ", _jsx(_components.code, {
            children: "outputs"
          }), " 的 glob 语法"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥How ", _jsx(_components.code, {
            children: "turbo"
          }), " interpreted your glob syntax for ", _jsx(_components.code, {
            children: "inputs"
          }), " and ", _jsx(_components.code, {
            children: "outputs"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "两次任务运行之间哪些输入发生了变化会导致缓存未命中？"
        }), "\n", _jsx(_components.p, {
          children: "¥What inputs changed between two task runs to produce a cache miss"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "任务时间如何随时间变化"
        }), "\n", _jsx(_components.p, {
          children: "¥How task timings changed over time"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Summaries viewer",
      children: [_jsx(_components.p, {
        children: "虽然 Turborepo 本身没有运行摘要 UI 查看器，但有一些社区开发的工具可供使用："
      }), _jsx(_components.p, {
        children: "¥While there is not a Turborepo-native Run Summaries UI viewer, there are\nseveral community-built tools available:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.a, {
              href: "https://turbo.nullvoxpopuli.com",
              children: "https://turbo.nullvoxpopuli.com"
            }), " - 基于 Web 的运行摘要 UI 查看器"]
          }), "\n", _jsxs(_components.p, {
            children: ["¥", _jsx(_components.a, {
              href: "https://turbo.nullvoxpopuli.com",
              children: "https://turbo.nullvoxpopuli.com"
            }), " - Web-based UI viewer for Run Summaries"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.a, {
              href: "https://github.com/charpeni/turborepo-summary",
              children: _jsx(_components.code, {
                children: "turborepo-summary"
              })
            }), " - 从 Turborepo 运行摘要 JSON 输出生成易于阅读的报告"]
          }), "\n", _jsxs(_components.p, {
            children: ["¥", _jsx(_components.a, {
              href: "https://github.com/charpeni/turborepo-summary",
              children: _jsx(_components.code, {
                children: "turborepo-summary"
              })
            }), " - Generate human-readable reports from Turborepo run summary JSON output"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.a, {
              href: "https://github.com/charpeni/turborepo-summary-action",
              children: _jsx(_components.code, {
                children: "turborepo-summary-action"
              })
            }), " - GitHub Action 将 ", _jsx(_components.code, {
              children: "turborepo-summary"
            }), " 封装起来，并将其附加到 GitHub Actions 作业摘要"]
          }), "\n", _jsxs(_components.p, {
            children: ["¥", _jsx(_components.a, {
              href: "https://github.com/charpeni/turborepo-summary-action",
              children: _jsx(_components.code, {
                children: "turborepo-summary-action"
              })
            }), " - GitHub Action wrapping ", _jsx(_components.code, {
              children: "turborepo-summary"
            }), " to append them to GitHub Actions Job Summary"]
          }), "\n"]
        }), "\n"]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--token---token",
      children: [_jsx(_components.code, {
        children: "--token"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["用于远程缓存的承载令牌。与 ", _jsx(_components.code, {
        children: "--team"
      }), " 标志结合使用，在非交互式 shell 中运行非常有用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A bearer token for Remote Caching. Useful for running in non-interactive shells in combination with the ", _jsx(_components.code, {
        children: "--team"
      }), " flag."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --team=my-team"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --token=xxxxxxxxxxxxxxxxx"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["此值也可以使用 ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: [_jsx(_components.code, {
          children: "TURBO_TOKEN"
        }), " 系统变量"]
      }), " 设置。如果两者都存在，则标志值将覆盖系统变量。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This value can also be set using ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: ["the ", _jsx(_components.code, {
          children: "TURBO_TOKEN"
        }), " system variable"]
      }), ". If both are present, the flag value will override the system variable."]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["如果你正在使用 ", _jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching",
          children: "Vercel 远程缓存"
        }), " 并在 Vercel 上构建项目，则无需使用此标志。此值将自动为你设置。"]
      }), _jsxs(_components.p, {
        children: ["¥If you are using ", _jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching",
          children: "Vercel Remote\nCache"
        }), " and building your\nproject on Vercel, you do not need to use this flag. This value will be\nautomatically set for you."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "--team---team",
      children: [_jsx(_components.code, {
        children: "--team"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["远程缓存团队的 slug。与 ", _jsx(_components.code, {
        children: "--token"
      }), " 标志结合使用，在非交互式 shell 中运行非常有用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The slug of the Remote Cache team. Useful for running in non-interactive shells in combination with the ", _jsx(_components.code, {
        children: "--token"
      }), " flag."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --team=my-team"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --team=my-team"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --token=xxxxxxxxxxxxxxxxx"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["此值也可以使用 ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: [_jsx(_components.code, {
          children: "TURBO_TEAM"
        }), " 系统变量"]
      }), " 设置。如果两者都存在，则标志值将覆盖系统变量。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This value can also be set using ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: ["the ", _jsx(_components.code, {
          children: "TURBO_TEAM"
        }), " system variable"]
      }), ". If both are present, the flag value will override the system variable."]
    }), "\n", _jsxs(_components.h3, {
      id: "--ui---ui",
      children: [_jsx(_components.code, {
        children: "--ui"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["指定用于输出的 UI。接受 ", _jsx(_components.code, {
        children: "stream"
      }), " 或 ", _jsx(_components.code, {
        children: "tui"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Specify the UI to use for output. Accepts ", _jsx(_components.code, {
        children: "stream"
      }), " or ", _jsx(_components.code, {
        children: "tui"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "--verbosity---verbosity",
      children: [_jsx(_components.code, {
        children: "--verbosity"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["要指定日志级别，请使用 ", _jsx(_components.code, {
        children: "--verbosity=<num>"
      }), " 或 ", _jsx(_components.code, {
        children: "-v, -vv, -vvv"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To specify log level, use ", _jsx(_components.code, {
        children: "--verbosity=<num>"
      }), " or ", _jsx(_components.code, {
        children: "-v, -vv, -vvv"
      }), "."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "级别"
          }), _jsx(_components.th, {
            children: "标志值"
          }), _jsx(_components.th, {
            children: "简写"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "信息"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--verbosity=1"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "-v"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "调试"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--verbosity=2"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "-vv"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "跟踪"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--verbosity=3"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "-vvv"
            })
          })]
        })]
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --verbosity=2"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -vvv"
            })]
          })]
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
